import React from 'react';
import type { PolicyBlock } from './legalDocumentTypes';

export const renderPolicyBlock = (
    block: PolicyBlock,
    index: number
): React.ReactNode => {
    switch (block.type) {
        case 'paragraph':
            return <p key={index}>{block.text}</p>;
        case 'heading':
            return <h3 key={index}>{block.text}</h3>;
        case 'list':
            return (
                <ul key={index}>
                    {block.items.map((item, itemIndex) => (
                        <li key={itemIndex}>{item}</li>
                    ))}
                </ul>
            );
        case 'labeledList':
            return (
                <ul key={index}>
                    {block.items.map((item, itemIndex) => (
                        <li key={itemIndex}>
                            <strong>{item.label}:</strong> {item.text}
                        </li>
                    ))}
                </ul>
            );
        case 'contact':
            return (
                <div key={index} className="contact-info">
                    {block.items.map((item, itemIndex) => (
                        <p key={itemIndex}>
                            <strong>{item.label}:</strong> {item.text}
                        </p>
                    ))}
                </div>
            );
        default:
            return null;
    }
};
